<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        <template v-if="priceData.id">{{ $t('price.editPrice') }}</template>
        <template v-else>{{ $t('price.addPrice') }}</template>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="contractor-price-form" tag="form">
          <div class="form-group">
            <label for="name">
              {{ $t('contractor.service') }}:
            </label>

            <validation-provider
              rules="required"
              name="service-id"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                <v-select
                  v-model="service_id"
                  :state="errors.length ? 'invalid' : null"
                  :reduce="(service) => service.id"
                  :placeholder="$t('service.chooseService')"
                  label="code"
                  :options="services" />
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('settings.currency.currency') }}:
            </label>

            <validation-provider
              rules="required"
              name="currency-id"
              v-slot="{ errors }">
              <d-form-select
                v-model="currency_id"
                :state="errors.length ? 'invalid' : null"
                :options="currenciesOptions" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('price.price') }}:
            </label>

            <validation-provider
              rules="required"
              name="price"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="price" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <d-checkbox
              inline
              v-model="is_setup"
              toggle
              toggle-small>
              {{ $t('price.chosenPriceIsSetupPrice') }}
            </d-checkbox>
          </div>

          <div class="form-group">
            <label>
              <template v-if="is_setup">{{ $t('price.quantityFrom') }}:</template>
              <template v-else>{{ $t('price.quantityTo') }}:</template>
            </label>

            <validation-provider
              rules="required"
              name="value_from"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="value_from" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="saveInProgress"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="saveInProgress"
        @click.prevent="validateForm">
        <div
          v-if="saveInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        {{ $t('ui.save') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import CommonGetters from './../../utils/CommonGetters.js';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'contractor-price-popup',
  props: {
    priceData: {
      default: () => ({}),
      type: Object
    },
    contractorId: {
      default: 0,
      type: Number
    },
    currencies: {
      default: () => ([]),
      type: Array
    },
    services: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    currenciesOptions () {
      return CommonGetters.getCurrenciesForSelect(this.currencies);
    }
  },
  data () {
    return {
      currency_id: 0,
      service_id: null,
      value_from: 0,
      price: 0,
      is_setup: false,
      saveInProgress: false
    };
  },
  mounted () {
    this.currency_id = this.priceData.currency_id || this.currencies[0].id;
    this.service_id = this.priceData.service_id || null;
    this.value_from = this.priceData.value_from || 0;
    this.price = this.priceData.price || 0;
    this.is_setup = !!(this.priceData.is_setup || false);
    this.saveInProgress = false;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('contractor-price-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['contractor-price-form'], this.save);
    },
    save () {
      this.saveInProgress = true;

      let formData = {
        contractor_id: this.contractorId,
        currency_id: this.currency_id,
        service_id: this.service_id,
        value_from: this.value_from,
        price: this.price,
        is_setup: +this.is_setup
      };

      let endpoint = '/contractors/prices/store';

      if (this.priceData.id) {
        endpoint = '/contractors/prices/update/' + parseInt(this.priceData.id, 10);
      }

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint,
        formData,
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('ui.saveChangesErrorText'),
        successAction: () => {
          this.saveInProgress = false;
          this.$bus.$emit('contractor-prices-reload-needed');
          this.cancel();
        },
        failAction: () => {
          this.saveInProgress = false;
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
